module.exports = __webpack_public_path__ + "img/qq-circle.3af88276.svg";